export const getLocalToken = () => localStorage.getItem('token');

export const saveLocalToken = (token: string) => localStorage.setItem('token', token);

export const removeLocalToken = () => localStorage.removeItem('token');

export const shortenText = (text, maxLength) => text.length > maxLength ? `${text.slice(0, maxLength)}...` : text